export default __webpack_public_path__ + "static/media/download_2.8f385824.png";